// import React, { useState, useEffect } from 'react';
// import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
// import 'react-tabs/style/react-tabs.css';
// import Select from 'react-select';
// import { useContext } from 'react';
// import UserContext from '../../Context/UserContext';
// import { Flex, Flexed } from '../../utilities/Shared';

// const PressSheetEstimator = ({ quoteInfo, setQuoteInfo, papers }) => {
//   const [items, setItems] = useState([]);
//   const [activeIndex, setActiveIndex] = useState(0);

//   const { presses } = useContext(UserContext);
//   const methods = ['Work & Turn','Work & Tumble','One-Sided','Sheetwise','Perfect'];

//   console.log(presses);

//   // ✅ FIXED LOAD (no overwrite)
//   useEffect(() => {
//     if (!items?.length && quoteInfo?.forms?.length) {
//       setItems(quoteInfo.forms);
//     }
//   }, [quoteInfo?.forms]);

//   // ✅ AUTO SYNC (single source of truth)
//   useEffect(() => {
//     if (!items) return;

//     setQuoteInfo(prev => ({
//       ...prev,
//       forms: items
//     }));
//   }, [items]);

//   // Add a new item
//   const addNewItem = () => {
//     const newItem = {
//       basisWeight:"",
//       binks:"",
//       componentKey:"",
//       componentName:"New Comp",
//       finks:"",
//       flatLength:"",
//       flatWidth:"",
//       foldLength:"",
//       foldWidth:"",
//       id:Date.now(),
//       mWeight:"",
//       name:"",
//       paper:{},
//       pressNotes:"",
//       raw:"",
//     };

//     setItems(prev => [...prev, newItem]);
//     setActiveIndex(items?.length);
//   };

//   useEffect(() => {
//     if(activeIndex){
//       console.log(items[activeIndex]?.id);
//     }
//   },[items[activeIndex]?.finks,items[activeIndex]?.binks]);

//   // Update a field in an item
//   const updateItem = (id, field, value) => {
//     const updatedItems = items?.map(item =>
//       item.id === id ? { ...item, [field]: value } : item
//     );
//     setItems(updatedItems);
//   };

//   const changepaper = (selected, item) => {
//     if (!selected) return;
//     const selectedPaper = { ...selected.paper };
//     updateItem(item.id, 'paper', selectedPaper);
//   };

// const inkchange = (id, field, value) => {
//   const plateField = field === 'finks' ? 'fplates'
//                    : field === 'binks' ? 'bplates'
//                    : null;

//   const plateCount = plateField
//     ? value.split(',').filter(Boolean).length
//     : null;

//   setItems(prev =>
//     prev.map(item =>
//       item.id === id
//         ? {
//             ...item,
//             [field]: value,
//             ...(plateField && { [plateField]: plateCount })
//           }
//         : item
//     )
//   );
// };


//   // Delete an item
//   const deleteItem = (id) => {
//     if (items.length <= 1) return;
//     const updatedItems = items.filter(item => item.id !== id);
//     setItems(updatedItems);
//     setActiveIndex(prev => Math.max(0, prev - 1));
//   };

//   const inkCost = 0;
//   const pressCost = 0;

//   const options = papers?.map(paper => ({
//     value: paper.stockid,
//     label: paper.name,
//     category: paper.category,
//     paper
//   }));

//   const pressOptions = presses?.map(press => ({
//     value: press.id || press.name || press.pressId,
//     label: press.name || press.description || press.pressName || 'Unnamed Press',
//     pressData: press,
//   })) || [];

//   console.log(quoteInfo);

//   return (
//     <div className="mx-auto p-6 bg-white rounded-2xl shadow-lg">
//       <div className="flex justify-between items-center mb-6">
//         <h2 className="text-3xl font-bold text-teal-700">Press Sheet Estimator</h2>
//         <button
//           onClick={addNewItem}
//           className="flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-xl font-medium transition"
//         >
//           + Add New Item
//         </button>
//       </div>

//       {items?.length === 0 ? (
//         <div className="text-center py-12 text-gray-500">
//           No press runs found. Click "Add New Item" to start.
//         </div>
//       ) : (
//         <Tabs selectedIndex={activeIndex} onSelect={setActiveIndex}>
//           <TabList className="flex border-b border-gray-200 mb-3 overflow-x-auto" style={{borderBottom:'1px solid #0F766E'}}>
//             {items?.map((item) => (
//               <Tab
//                 key={item.id}
//                 className="px-6 py-3 text-lg font-medium cursor-pointer border-b-4 border-transparent hover:border-teal-300 data-[selected]:border-teal-600 data-[selected]:text-teal-700 outline-none"
//               >
//                 {item.componentName}
//               </Tab>
//             ))}
//           </TabList>

//           {items?.map((item,index) => (
//             <TabPanel key={item.id}>
//               <div className="bg-gray-50 rounded-2xl p-4">

//                 {/* Duplicate */}
//                 <div className="mb-8 flex flex-col sm:flex-row sm:items-end gap-4">
//                   <div className="flex items-center gap-3">
//                     <button
//                       onClick={() => {
//                         const duplicated = {
//                           ...item,
//                           id: Date.now(),
//                           componentName: item.componentName ? `${item.componentName} ` : `New Form`,
//                           paper: item.paper ? { ...item.paper } : null
//                         };
//                         const updatedItems = [...items];
//                         updatedItems.splice(activeIndex + 1, 0, duplicated);
//                         setItems(updatedItems);
//                         setActiveIndex(activeIndex + 1);
//                       }}
//                       className="px-5 py-3 bg-teal-50 hover:bg-teal-100 text-teal-700 border border-teal-200 rounded-xl font-medium transition flex items-center gap-2"
//                     >
//                       📋 Duplicate
//                     </button>
//                   </div>

//                   {/* Name */}
//                   <div className="min-w-0" style={{flex:'.6'}}>
//                     <label className="block text-md font-medium text-gray-700 mb-1">Form Name</label>
//                     <input
//                       type="text"
//                       value={item.componentName || ''}
//                       onChange={(e) => updateItem(item.id, 'componentName', e.target.value)}
//                       className="w-full px-4 py-3 border border-gray-300 rounded-xl"
//                       style={{ height: '34px' }}
//                     />
//                   </div>

//                   {/* Paper */}
//                   <div className="sm:w-80" style={{flex:'1'}}>
//                     <label className="block text-md font-medium text-gray-700 mb-1">Stock</label>
//                     <Select
//                       options={options}
//                       onChange={(selected) => changepaper(selected, item)}
//                       value={
//                         item.paper
//                           ? { value: item.paper.stockid, label: item.paper.name, paper: item.paper }
//                           : null
//                       }
//                     />
//                   </div>

//                   <input value={item.paper?.stockid || ''} disabled />
//                 </div>

//            {/* Rest of the fields */}
//                 <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//    {/* PRESS – now a dropdown */}
//    <div>
//      <label className="block text-md font-medium text-gray-700 mb-1">Press</label>
//      <Select
//        options={pressOptions}
//        value={
//          item.press
//            ? pressOptions.find(opt => opt.value === (item.press?.id || item.press?.name || item.press))
//            : null
//        }
//        onChange={(selected) => {
//          if (!selected) {
//            updateItem(item.id, 'press', null);
//            return;
//          }
//          // Option A: store full press object (recommended if you need more properties later)
//          updateItem(item.id, 'press', selected.press);
        
//          // Option B: store just name or ID (simpler)
//          // updateItem(item.id, 'press', selected.value);
//        }}
//        placeholder="Select press..."
//        isClearable
//        className="text-base"
//      />
//    </div>
//  {/* METHOD – simple string dropdown */}
//    <div>
//      <label className="block text-md font-medium text-gray-700 mb-1">Method</label>
//      <Select
//        options={methods.map(m => ({ value: m, label: m }))}
//        value={
//          item.method
//            ? { value: item.method, label: item.method }
//            : null
//        }
//        onChange={(selected) => {
//          updateItem(item.id, 'method', selected?.value || null);
//        }}
//        placeholder="Select method..."
//        isClearable
//        className="text-base"
//      />
//    </div>
//                    <div className="grid grid-cols-3 gap-4">
                  
//                      <div>
//                        <label className="block text-md font-medium text-gray-700 mb-1">Versions</label>
//                        <input
//                          type="number"
//                          step="1"
//                          value={item.versions || 0}
//                          onChange={(e) => updateItem(item.id, 'versions', Number(e.target.value) || 0)}
//                          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-teal-600"
//                        />
//                      </div>
//                         <div>
//                        <label className="block text-md font-medium text-gray-700 mb-1">Pages</label>
//                        <input
//                          type="number"
//                          step="2"
//                          value={item.pagecount || 0}
//                          onChange={(e) => updateItem(item.id, 'pagecount', Number(e.target.value) || 0)}
//                          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-teal-600"
//                        />
//                      </div>
//                         <div>
//                        <label className="block text-md font-medium text-gray-700 mb-1">Forms</label>
//                        <input
//                          type="number"
//                          step="1"
//                          value={item.forms || 0}
//                          onChange={(e) => updateItem(item.id, 'forms', Number(e.target.value) || 0)}
//                          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-teal-600"
//                        />
//                      </div>
//                    </div>
//     </div>

//      <div className="grid grid-cols-1 gap-4 pt-10">
//          <Flexed gap="15px">
//                    <Flex>
//                      <label className="block text-md font-medium text-gray-700 mb-1">Front Inks</label>
//                      <input
//                        type="text"
//                        value={item.finks || 0}
//                        onChange={(e) => inkchange(item.id, 'finks', e.target.value,index)}
//                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-teal-600"
//                      />
//                    </Flex>

//                    <Flex flex=".5">
//                      <label className="block text- font-medium text-gray-700 mb-1">Coverage %</label>
//                      <input
//                        type="number"
//                        step="0.01"
//                        value={item.fpercent || 0}
//                        onChange={(e) => updateItem(item.id, 'fpercent', Number(e.target.value) || 0)}
//                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-teal-600"
//                      />
//                    </Flex>

//                    <Flex>
//                      <label className="block text-md font-medium text-gray-700 mb-1">Coating 1 </label>
//                      <input
                     
//                        value={item.inkCostPerLb || 0}
//                        onChange={(e) => updateItem(item.id, 'inkCostPerLb', Number(e.target.value) || 0)}
//                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-teal-600"
//                      />
//                    </Flex>
//                      <Flex>
//                      <label className="block text-md font-medium text-gray-700 mb-1">Coating 2 </label>
//                      <input
                     
                    
//                        value={item.inkCostPerLb || 0}
//                        onChange={(e) => updateItem(item.id, 'inkCostPerLb', Number(e.target.value) || 0)}
//                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-teal-600"
//                      />
//                    </Flex>
//                      <Flex flex=".3">
//                      <label className="block text-md font-medium text-gray-700 mb-1">Passes</label>
//                      <input
//                        type="number"
//                        step="1"
//                        value={item.inkCostPerLb || 0}
//                        onChange={(e) => updateItem(item.id, 'inkCostPerLb', Number(e.target.value) || 0)}
//                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-teal-600"
//                      />
//                    </Flex>
//                    <Flex flex=".3">
//                      <label className="block text-md font-medium text-gray-700 mb-1">Plates</label>
//                      <input
//                        type="number"
//                        step="1"
//                        value={item.fplates || 0}
//                        onChange={(e) => updateItem(item.id, 'fplates', Number(e.target.value) || 0)}
//                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-teal-600"
//                      />
//                    </Flex>
//                    </Flexed>
//                    </div>
     
              
//           <div className="grid grid-cols-1 gap-4 pt-5">
//          <Flexed gap="15px">
//                    <Flex>
//                      <label className="block text-md font-medium text-gray-700 mb-1">Back Inks</label>
//                      <input
//                        type="text"
//                        value={item.binks || 0}
//                        onChange={(e) => updateItem(item.id, 'binks',e.target.value || "")}
//                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-teal-600"
//                      />
//                    </Flex>

//                    <Flex flex=".5">
//                      <label className="block text-md font-medium text-gray-700 mb-1">Coverage %</label>
//                      <input
//                        type="number"
//                        step="0.01"
//                        value={item.bpercent || 0}
//                        onChange={(e) => updateItem(item.id, 'bpercent', Number(e.target.value) || 0)}
//                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-teal-600"
//                      />
//                    </Flex>

//                    <Flex>
//                      <label className="block text-md font-medium text-gray-700 mb-1">Coating 1 </label>
//                      <input
//                        type="number"
//                        step="0.01"
//                        value={item.inkCostPerLb || 0}
//                        onChange={(e) => updateItem(item.id, 'inkCostPerLb', Number(e.target.value) || 0)}
//                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-teal-600"
//                      />
//                    </Flex>
//                      <Flex>
//                      <label className="block text-md font-medium text-gray-700 mb-1">Coating 2 </label>
//                      <input
//                        type="number"
//                        step="0.01"
//                        value={item.inkCostPerLb || 0}
//                        onChange={(e) => updateItem(item.id, 'inkCostPerLb', Number(e.target.value) || 0)}
//                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-teal-600"
//                      />
//                    </Flex>
//                      <Flex flex=".3">
//                      <label className="block text-md font-medium text-gray-700 mb-1">Passes</label>
//                      <input
//                        type="number"
//                        step="1"
//                        value={item.bpasses || 0}
//                        onChange={(e) => updateItem(item.id, 'bpasses', Number(e.target.value) || 0)}
//                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-teal-600"
//                      />
//                    </Flex>
//                         <Flex flex=".3">
//                      <label className="block text-md font-medium text-gray-700 mb-1">Plates</label>
//                      <input
//                        type="number"
//                        step="1"
//                        value={item.bplates || 0}
//                        onChange={(e) => updateItem(item.id, 'bplates', Number(e.target.value) || 0)}
//                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-teal-600"
//                      />
//                    </Flex>
//                    </Flexed>
//                    </div>


//                 {/* Results */}
//                 <div className="mt-10 bg-white border border-teal-200 rounded-2xl p-8">
//                   <h3 className="text-xl font-semibold text-teal-700 mb-4">
//                     Cost Summary — {item.name || 'Unnamed'}
//                   </h3>
//                   <div className="grid grid-cols-2 gap-6 text-lg">
//                     <div>
//                       <p className="text-gray-600">Total Ink Cost</p>
//                       <p className="text-3xl font-bold text-teal-600">${inkCost}</p>
//                     </div>
//                     <div>
//                       <p className="text-gray-600">Estimated Press Cost</p>
//                       <p className="text-3xl font-bold text-teal-600">${pressCost}</p>
//                     </div>
//                   </div>
//                 </div>

//                 {items.length > 1 && (
//                   <button
//                     onClick={() => deleteItem(item.id)}
//                     className="mt-6 text-red-600"
//                   >
//                     🗑️ Delete this item
//                   </button>
//                 )}

//               </div>
//             </TabPanel>
//           ))}
//         </Tabs>
//       )}
//     </div>
//   );
// };

// export default PressSheetEstimator;



import React, { useState, useContext, useCallback } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Select from 'react-select';
import UserContext from '../../Context/UserContext';
import { Flex, Flexed } from '../../utilities/Shared';

const PressSheetEstimator = ({ quoteInfo, setQuoteInfo, papers }) => {
  const { presses } = useContext(UserContext);
  const [activeIndex, setActiveIndex] = useState(0);
  const methods = ['Work & Turn', 'Work & Tumble', 'One-Sided', 'Sheetwise', 'Perfect'];

  const forms = quoteInfo?.forms || [];

  const updateForm = useCallback((formId, field, value) => {
    setQuoteInfo(prev => ({
      ...prev,
      forms: (prev.forms || []).map(form =>
        form.id === formId ? { ...form, [field]: value } : form
      ),
    }));
  }, [setQuoteInfo]);

  const addNewItem = () => {
    const newForm = {
      id: Date.now(),
      componentName: `Form ${forms.length + 1}`,
      paper: null, // store only stockid
      press: null, // store only press id
      method: null,
      versions: 0,
      pagecount: 0,
      forms: 1,
      finks: '',
      fpercent: 0,
      faq1: '',
      faq2: '',
      fplates: 0,
      binks: '',
      bpercent: 0,
      baq1: '',
      baq2: '',
      bplates: 0,
    };

    setQuoteInfo(prev => ({
      ...prev,
      forms: [...(prev.forms || []), newForm],
    }));

    setActiveIndex(forms.length);
  };

  const duplicateForm = (formId) => {
    const current = forms.find(f => f.id === formId);
    if (!current) return;

    const duplicated = { ...current, id: Date.now(), componentName: `${current.componentName} (Copy)` };
    const idx = forms.findIndex(f => f.id === formId);

    setQuoteInfo(prev => ({
      ...prev,
      forms: [...prev.forms.slice(0, idx + 1), duplicated, ...prev.forms.slice(idx + 1)],
    }));

    setActiveIndex(idx + 1);
  };

  const deleteForm = (formId) => {
    if (forms.length <= 1) return;
    const idx = forms.findIndex(f => f.id === formId);
    setQuoteInfo(prev => ({
      ...prev,
      forms: prev.forms.filter(f => f.id !== formId),
    }));
    setActiveIndex(Math.max(0, idx - 1));
  };

  const paperOptions = papers?.map(p => ({ value: p.stockid, label: p.name, paper: p })) || [];
  const pressOptions = presses?.map(p => ({
    value: p.id || p.name,
    label: p.id === '5' || p.id === '6' ? `${p.pname || ''} ${p.description || ''}`.trim() : p.pname || 'Unnamed Press',
    pressData: p,
  })) || [];

  // Handle paper change by storing only stockid
  const handlePaperChange = (selected, formId) => {
    updateForm(formId, 'paper', selected ? selected.value : null);
  };

  // Handle press change by storing only press id
  const handlePressChange = (selected, formId) => {
    updateForm(formId, 'press', selected ? selected.value : null);
  };

  return (
    <div className="mx-auto p-6 bg-white rounded-2xl shadow-lg">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-3xl font-bold text-teal-700">Press Sheet Estimator</h2>
        <button
          onClick={addNewItem}
          className="flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-xl font-medium transition"
        >
          + Add New Item
        </button>
      </div>

      {forms.length === 0 ? (
        <div className="text-center py-12 text-gray-500">No forms yet. Click "Add New Item" to start.</div>
      ) : (
        <Tabs selectedIndex={activeIndex} onSelect={setActiveIndex}>
          <TabList className="flex border-b border-gray-200 mb-6 overflow-x-auto" style={{ borderBottom: '1px solid #0F766E' }}>
            {forms.map((form, idx) => (
              <Tab
                key={form.id}
                className="px-6 py-3 text-lg font-medium cursor-pointer border-b-4 border-transparent hover:border-teal-300 data-[selected]:border-teal-600 data-[selected]:text-teal-700 outline-none whitespace-nowrap"
              >
                {form.componentName || `Form ${idx + 1}`}
              </Tab>
            ))}
          </TabList>

          {forms.map(form => {
            // Get actual paper object for display
            const paperObj = papers?.find(p => p.stockid === form.paper);
            const pressObj = presses?.find(p => (p.id || p.name) === form.press);

            return (
              <TabPanel key={form.id}>
                <div className="bg-gray-50 rounded-2xl p-6 space-y-8">

                  {/* Header Row */}
                  <div className="flex flex-col sm:flex-row gap-4 items-end">
                    <button
                      onClick={() => duplicateForm(form.id)}
                      className="px-5 py-3 bg-teal-50 hover:bg-teal-100 text-teal-700 border border-teal-200 rounded-xl font-medium flex items-center gap-2"
                    >
                      📋 Duplicate
                    </button>

                    <div className="flex-1">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Form Name</label>
                      <input
                        type="text"
                        value={form.componentName || ''}
                        onChange={(e) => updateForm(form.id, 'componentName', e.target.value)}
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-teal-600"
                      />
                    </div>

                    <div className="w-80">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Stock</label>
                      <Select
                        options={paperOptions}
                        value={paperOptions.find(o => o.value === form.paper) || null}
                        onChange={(sel) => handlePaperChange(sel, form.id)}
                        placeholder="Select paper..."
                        isClearable
                      />
                    </div>

                    <div className="w-24">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Stock ID</label>
                      <input
                        type="text"
                        value={paperObj?.stockid || ''}
                        disabled
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl bg-gray-100"
                      />
                    </div>
                  </div>

                  {/* Press / Method / Numbers */}
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Press</label>
                      <Select
                        options={pressOptions}
                        value={pressOptions.find(o => o.value === form.press) || null}
                        onChange={(sel) => handlePressChange(sel, form.id)}
                        placeholder="Select press..."
                        isClearable
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Method</label>
                      <Select
                        options={methods.map(m => ({ value: m, label: m }))}
                        value={form.method ? { value: form.method, label: form.method } : null}
                        onChange={(sel) => updateForm(form.id, 'method', sel?.value || null)}
                        placeholder="Select method..."
                        isClearable
                      />
                    </div>

                    <div className="grid grid-cols-3 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Versions</label>
                        <input
                          type="number"
                          value={form.versions || 0}
                          onChange={(e) => updateForm(form.id, 'versions', Number(e.target.value) || 0)}
                          className="w-full px-4 py-3 border border-gray-300 rounded-xl"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Pages</label>
                        <input
                          type="number"
                          value={form.pagecount || 0}
                          onChange={(e) => updateForm(form.id, 'pagecount', Number(e.target.value) || 0)}
                          className="w-full px-4 py-3 border border-gray-300 rounded-xl"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Forms</label>
                        <input
                          type="number"
                          value={form.forms || 1}
                          onChange={(e) => updateForm(form.id, 'forms', Number(e.target.value) || 1)}
                          className="w-full px-4 py-3 border border-gray-300 rounded-xl"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Inks & Coatings */}
                  <div style={{ border: '1px solid #418DA7', padding: '20px', borderRadius: '12px' }}>
                    <h4 className="font-semibold text-teal-700 mb-6">Inks & Coatings</h4>

                    {/* Front */}
                    <div className="mb-10">
                      <h5 className="font-medium text-lg mb-4 text-teal-600">Front Side</h5>
                      <Flexed gap="12px" className="flex-wrap">
                        <Flex><label>Front Inks</label><input type="text" value={form.finks || ''} onChange={e => updateForm(form.id, 'finks', e.target.value)} className="w-full px-4 py-3 border border-gray-300 rounded-xl" /></Flex>
                        <Flex flex="0.4"><label>Coverage %</label><input type="number" step="0.01" value={form.fpercent || 0} onChange={e => updateForm(form.id, 'fpercent', Number(e.target.value) || 0)} className="w-full px-4 py-3 border border-gray-300 rounded-xl" /></Flex>
                        <Flex><label>Front AQ 1</label><input type="text" value={form.faq1 || ''} onChange={e => updateForm(form.id, 'faq1', e.target.value)} className="w-full px-4 py-3 border border-gray-300 rounded-xl" /></Flex>
                        <Flex><label>Front AQ 2</label><input type="text" value={form.faq2 || ''} onChange={e => updateForm(form.id, 'faq2', e.target.value)} className="w-full px-4 py-3 border border-gray-300 rounded-xl" /></Flex>
                        <Flex flex="0.3"><label>Plates</label><input type="number" value={form.fplates || 0} onChange={e => updateForm(form.id, 'fplates', Number(e.target.value) || 0)} className="w-full px-4 py-3 border border-gray-300 rounded-xl" /></Flex>
                      </Flexed>
                    </div>

                    {/* Back */}
                    <div>
                      <h5 className="font-medium text-lg mb-4 text-teal-600">Back Side</h5>
                      <Flexed gap="12px" className="flex-wrap">
                        <Flex><label>Back Inks</label><input type="text" value={form.binks || ''} onChange={e => updateForm(form.id, 'binks', e.target.value)} className="w-full px-4 py-3 border border-gray-300 rounded-xl" /></Flex>
                        <Flex flex="0.4"><label>Coverage %</label><input type="number" step="0.01" value={form.bpercent || 0} onChange={e => updateForm(form.id, 'bpercent', Number(e.target.value) || 0)} className="w-full px-4 py-3 border border-gray-300 rounded-xl" /></Flex>
                        <Flex><label>Back AQ 1</label><input type="text" value={form.baq1 || ''} onChange={e => updateForm(form.id, 'baq1', e.target.value)} className="w-full px-4 py-3 border border-gray-300 rounded-xl" /></Flex>
                        <Flex><label>Back AQ 2</label><input type="text" value={form.baq2 || ''} onChange={e => updateForm(form.id, 'baq2', e.target.value)} className="w-full px-4 py-3 border border-gray-300 rounded-xl" /></Flex>
                        <Flex flex="0.3"><label>Plates</label><input type="number" value={form.bplates || 0} onChange={e => updateForm(form.id, 'bplates', Number(e.target.value) || 0)} className="w-full px-4 py-3 border border-gray-300 rounded-xl" /></Flex>
                      </Flexed>
                    </div>
                  </div>

                  {/* Cost Summary */}
                  <div className="mt-10 bg-white border border-teal-200 rounded-2xl p-8">
                    <h3 className="text-xl font-semibold text-teal-700 mb-4">
                      Cost Summary — {form.componentName || 'Unnamed'}
                    </h3>
                    <div className="grid grid-cols-2 gap-8">
                      <div>
                        <p className="text-gray-600">Total Ink Cost</p>
                        <p className="text-3xl font-bold text-teal-600">$0.00</p>
                      </div>
                      <div>
                        <p className="text-gray-600">Estimated Press Cost</p>
                        <p className="text-3xl font-bold text-teal-600">$0.00</p>
                      </div>
                    </div>
                  </div>

                  {forms.length > 1 && (
                    <button
                      onClick={() => deleteForm(form.id)}
                      className="mt-6 text-red-600 hover:text-red-700 flex items-center gap-2"
                    >
                      🗑️ Delete this Form
                    </button>
                  )}

                </div>
              </TabPanel>
            );
          })}
        </Tabs>
      )}
    </div>
  );
};

export default PressSheetEstimator;